import React from "react";
import Header from "./Header";

export default function Layout({ children }) {
  return (
    <div className="flex h-screen overflow-x-hidden">
      <div
        className={`flex-1 flex flex-col transition-all duration-300 py-4 pb-0`}
      >
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main className="mt-4 md:mt-10 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
